import AsyncStorage from '@react-native-async-storage/async-storage';
import {randomUUID} from 'expo-crypto';
import type {ForwardMediaSource} from '../services/api';

const pending=new Map<string,Promise<string>>();
function key(actor:number,destination:number,source:ForwardMediaSource){
  return `media-forward:${actor}:${destination}:${source.sourceId}:${source.sourceRevision}`;
}
/** Persist before POST. An uncertain request or cancelled sheet retains its key;
 * reopening must not create another object. No URLs, bodies or tokens are stored. */
export function forwardRequestId(actor:number,destination:number,source:ForwardMediaSource):Promise<string>{
  const slot=key(actor,destination,source),existing=pending.get(slot);
  if(existing)return existing;
  const work=(async()=>{
    const prior=await AsyncStorage.getItem(slot);
    if(prior){if(!/^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/.test(prior))throw Error('Invalid forward checkpoint');return prior;}
    const id=randomUUID();await AsyncStorage.setItem(slot,id);return id;
  })();
  pending.set(slot,work);work.finally(()=>{if(pending.get(slot)===work)pending.delete(slot);}).catch(()=>{});
  return work;
}
/** Only an acknowledged send may retire this logical request. */
export async function completeForwardRequest(actor:number,destination:number,source:ForwardMediaSource){
  await AsyncStorage.removeItem(key(actor,destination,source));
}
